var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{ref:"loadmoreContainer"},[_vm._t("default")],2),_vm._t("button",null,null,{ loadmore: _vm.loadmore ,visible:_vm.buttonVisible})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }